import * as React from 'react';

import type { W_ReportType_FindReportTypeViewTable_VM_Row } from 'ab-api/web/workOrderReport/reportTypeViewTable';

import * as TimeUtils from '@acceligentllc/shared/utils/time';

import { TimeFormat } from '@acceligentllc/shared/enums/timeFormat';

import Checkbox from 'af-components/Controls/Checkbox';

import styles from './styles.module.scss';
type Props = {
	reportType: W_ReportType_FindReportTypeViewTable_VM_Row;
	isChecked: boolean;
	onCheckboxClick: (isChecked: boolean, fieldReportTypeId: number) => void;
};

const ReportTypeRow: React.FC<Props> = ({ reportType, isChecked, onCheckboxClick }) => {

	const handleCheckboxChange = React.useCallback(() => {
		onCheckboxClick(isChecked, reportType.id);
	}, [isChecked, onCheckboxClick, reportType.id]);

	return (
		<div className={styles['report-type-row']}>
			<span>
				<Checkbox handleChange={handleCheckboxChange}
					isChecked={isChecked}
				/>
			</span >
			<b>
				{reportType.reportTypeName}
			</b>
			<span className={styles['report-type-row__small-text']}>
				{reportType.workOrderCode}
			</span>
			<span className={styles['report-type-row__small-text']}>
				{reportType.companyName}
			</span>
			<span className={styles['report-type-row__small-text']}>
				{TimeUtils.formatDate(reportType.startDate, TimeFormat.DATE_ONLY, TimeFormat.DB_DATE_ONLY)}
			</span>
		</div>
	);
};

export default React.memo(ReportTypeRow);
